import { EmptyState } from "../components/EmptyState";
import { nl } from "../i18n/nl";
import styles from "./Placeholder.module.css";

export function ScreenPlaceholder({ title, standalone = false }: { title: string; standalone?: boolean }) {
  const content = (
    <div className={styles.page}>
      <h1 className={styles.title}>{title}</h1>
      <EmptyState title={nl.placeholder.body} />
    </div>
  );
  // Inside the shell, <main> is provided by the layout.
  return standalone ? <main id="inhoud">{content}</main> : content;
}
